import { DocumentType } from './document-type.enum';

/**
 * Represents all of the data associated with a single document in an order.
 */
export class Document {
    name: string;
    id: string;
    dateUploaded: Date;

    /**
     * Constructs a new Document object given all of the fields.
     */
    constructor(name: string, id: string, dateUploaded: Date) {
        this.name = name;
        this.id = id;
        this.dateUploaded = dateUploaded;
    }

    /**
     * Converts documents in JSON form to a Map<string, Document[]>
     *
     * @param docJson documents in JSON form
     *
     * @return the new map of Documents
     */
    static jsonToDocuments(docJson: object): Map<string, Document[]> {
        const docs = new Map<string, Document[]>();
        if (docJson === undefined) {
            return docs;
        }
        Object.values(DocumentType).forEach((type: string) => {
            const docArr: Document[] = [];
            if (docJson[type]) {
                docJson[type].forEach((doc) => {
                    docArr.push(new Document(doc.name, doc.id, new Date(doc.dateUploaded)));
                });
            }
            docs.set(type, docArr);
        });
        return docs;
    }

    /**
     * Converts a Document map to an document object in JSON form as a string
     *
     * @param map the order to be converted
     *
     * @return the object JSON string
     */
    static documentsToObject(map: Map<string, Document[]>): object {
        const obj = {};
        Object.values(DocumentType).forEach((type) => {
            obj[type] = [];
            if (map.get(type)) {
                map.get(type).forEach((doc) => {
                    obj[type].push({
                        name: doc.name,
                        id: doc.id,
                        dateUploaded: doc.dateUploaded
                    });
                });
            }
        });
        return obj;
    }

    /**
     * Makes a deep copy of a document.
     *
     * @return the new document
     */
    clone(): Document {
        return new Document(this.name, this.id, this.dateUploaded);
    }
}
